import React, { useContext } from 'react';

import { ThemeContext } from '../../contexts/ThemeContext';
import { servicesData } from '../../data/servicesData';
import SingleService from './SingleService/SingleService';
import './Services.css';

function Services() {
    const { theme } = useContext(ThemeContext);

    if (!servicesData || servicesData.length === 0) {
        return null;
    }

    return (
        <div className="services" id="services" style={{ backgroundColor: theme.secondary }}>
            <div className="services-header">
                <h1 style={{ color: theme.primary }}>Services</h1>
            </div>
            
            <div className="services-body">
                <p style={{ color: theme.tertiary }}>
                    These are some of the services I offer. Reach out to me if I can help you with any!
                </p>
                
                <div className="services-bodycontainer">
                    {servicesData.map((service) => {
                        const { id, title, icon } = service;
                        
                        return (
                            <SingleService
                                key={id}
                                id={id}
                                title={title}
                                icon={icon}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default Services;